import React from "react";

/**
 * Renders the table's header row: index, question, then one column per period.
 *
 * @param {Object} props
 * @param {Array<{key: string, label: string}>} props.periods - Ordered period columns.
 * @returns {JSX.Element} The table head.
 */
const QuickViewTableHeader = ({ periods }) => (
  <thead>
    <tr className="qv-thead-row">
      <th className="qv-th qv-th--index">#</th>
      <th className="qv-th qv-th--question">Question</th>
      {periods.map(({ key, label }) => (
        <th key={key} className="qv-th qv-th--period">
          {label}
        </th>
      ))}
    </tr>
  </thead>
);

export default QuickViewTableHeader;
